import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import TableHeader from "../../layout/table/TableHeader.js";
import NoDataLabel from "../../layout/NoDataLabel.js";
import ModalDelete from "../../layout/ModalDelete.js";
import TypologieLavageBadge from "../../layout/TypologieLavageBadge.js";
import Constants from "../../../../utils/constants.js";

const headCells = [
    {id: "libelle", label: "Libellé"},
    {id: "typologie", label: "Typologie"},
    {id: "fichiers", label: "Fichiers"},
];

export default function ModeOperatoireTable({modes = [], onDelete}) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(null);

    const handleEditClick = (id) => navigate(Constants.APP_ROUTE_ADMIN_MODES_OPERATOIRES_EDIT.replace(":id", id));

    const openDeleteConfirmModal = (m) => {
        setCurrent(m);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setCurrent(null);
    };
    const handleDelete = () => {
        onDelete(current);
        handleClose();
    };

    return (
        <>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="modes operatoires table" size="small">
                    <TableHeader headCells={headCells}/>
                    <TableBody>
                        {modes.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={4} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucun mode opératoire enregistré"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {modes.map((m) => (
                            <TableRow key={m.id} hover style={{cursor: "pointer"}} onClick={() => handleEditClick(m.id)}>
                                <TableCell>{m.libelle}</TableCell>
                                <TableCell>
                                    {m.typologieLavage
                                        ? <TypologieLavageBadge typologie={m.typologieLavage}/>
                                        : "—"}
                                </TableCell>
                                <TableCell>{m.fichiers ? m.fichiers.length : 0}</TableCell>
                                <TableCell>
                                    <Stack direction={"row"} spacing={2} justifyContent={"end"}>
                                        <Button color="secondary" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditClick(m.id);
                                                }}
                                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                            Éditer
                                        </Button>
                                        <Button color="error" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDeleteConfirmModal(m);
                                                }}
                                                startIcon={<CloseOutlinedIcon/>}>
                                            Supprimer
                                        </Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ModalDelete
                label={"Êtes-vous sûr de vouloir supprimer le mode opératoire : "}
                onClose={handleClose}
                open={open}
                objectToDelete={current?.libelle}
                selectedValue={current}
                onDelete={handleDelete}
            />
        </>
    );
}
